module.exports = __webpack_public_path__ + "static/img/katun10.69a3426.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/blog/katun10.jpg
// module id = 249y
// module chunks = 0